var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81.1 157.1",
    style: {
      enableBackground: "new 0 0 81.1 157.1"
    },
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.t40{fill:#D4D3D7;}\n\t.t41{fill:#6C401D;}\n\t.t42{fill:#945225;}\n\t.t43{fill:#09A959;}\n\t.t44{fill:#068C45;}\n\t.st0{transform-origin: 50% 50%; transform-box: fill-box;}\n\t.st1{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st2{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st3{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st4{transform-origin: 50% 100%; transform-box: fill-box;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0 t40",
    cx: 40.1,
    cy: 151.4,
    rx: 31.4,
    ry: 5.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1 t41",
    points: "45.3,100.5 35.9,100.5 31.9,152.2 49.3,152.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2 t42",
    points: "40.6,152.2 49.3,152.2 45.3,100.5 40.6,100.5  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3 t43",
    cx: 40.6,
    cy: 51.7,
    rx: 40.6,
    ry: 51.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4 t44",
    d: "M40.6,83.2c-15.7,0-30.5-7.6-39.6-20.4c4,23.2,20.2,40.5,39.6,40.5c19.4,0,35.6-17.3,39.6-40.5   C71,75.6,56.3,83.2,40.6,83.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree4);
export default __webpack_public_path__ + "static/media/tree4.9141eebd1a0c1f2bf4fe3c088a2b46ac.svg";
export { ForwardRef as ReactComponent };